import { Outlet, ScrollRestoration } from 'react-router';

/** A raiz das rotas: cada tela nova abre no topo (o roteador, sozinho, deixaria a rolagem de onde estava) e "voltar" devolve a rolagem de antes. */
export function RootLayout() {
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
